// extracted by mini-css-extract-plugin
export default {"container":"AuthCallback_container__KVivH"};